export const breasts = {
  left: 'LEFT',
  right: 'RIGHT',
} as const;

export type breastType = typeof breasts[keyof typeof breasts];
